/* eslint-disable no-use-before-define */
import React from 'react'
import { MUNI_STATES_AND_TERRITORIES } from '../../../twd/twd'
import useScatterGraph from '../use-scatter-graph'

export default ({id}) => {

    const {activeState, setActiveState} = useScatterGraph()

    return <React.Fragment>
    <div className="select-wrapper">
    <select
        id={id}
        data-name="municipals-scatter-graph-active-state"
        className="form-control"
        value={activeState}
        onChange={(e) => {
            let a = e.target.value
            setActiveState(a)
        }}
    >
    {
        [{
            label: 'All',
            value: ''
        }]
        .concat(MUNI_STATES_AND_TERRITORIES)
        .map((a, i) => {
            let s = (a.value.split('=')[1] || '')
            return <option key={i} value={s}>{a.label}</option>
        })
    }
    </select>
    </div>
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/municipals/scatter-graph/criteria/active-state.js